import { ICommand, IDefineCommand } from 'core-ts-types';
import { AccountDatasource } from '../datasources/account_datasource';
import { ILocalDatabase } from 'utility-ts-database';

angular.module('capability-ng-user-app').factory(
  'resetLocalAccountCommand',
  (
    defineCommand: IDefineCommand,
    localDatabase: ILocalDatabase,
    applicationResetCommand: ICommand,
    ngAccountDatasource: AccountDatasource
  ): ICommand => {
    return defineCommand('resetLocalAccountCommand', function resetLocalAccountCommand(
      deferred: ng.IDeferred<AccountDatasource>
    ): void {
      localDatabase
        .ready()
        .then(() => {
          return ngAccountDatasource.reset();
        })
        .then(() => {
          return applicationResetCommand();
        })
        .then(() => {
          deferred.resolve(ngAccountDatasource);
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/user_app/commands/reset_local_account_command.ts